// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"91325021","902":"4e91f112"}[chunkId] + ".chunk.js";
};